<template>
  <div>
    <div v-for="(block, index) in blockList" class="data-card" :key="block.text">
      <p class="block-name">{{ block.text }}</p>
      <v-divider></v-divider>
      <div>
        <div v-for="(data1, deviceId) in groupedByBlock[block.id]" :key="deviceId">
          <v-divider></v-divider>
          <p class="device-name">{{ data1['name'] }}</p>
          <v-layout class="status-container" row wrap>
            <v-flex v-for="(value, param) in data1" :key="param" xs2>
              <div v-if="param != 'name' && healthyValues[param]['healthy_value'] != undefined" class="status-card" :class="value == healthyValues[param]['healthy_value'] ? 'status-on' : value == null ? 'no-status' : 'status-off'">
                <div class="truncate">{{ paramNameMap[deviceId][param] }}</div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    blockList: {
      type: Array,
      default: function() {
        return []
      }
    },
    groupedByBlock: {
      type: Object,
      default: function() {
        return {}
      }
    },
    healthyValues: {
      type: Object,
      default: function() {
        return {}
      }
    },
    paramNameMap: {
      type: Object,
      default: function() {
        return {}
      }
    }
  }
}
</script>

<style scoped>

.data-card {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 25px;
  background-color: var(--v-primary-base);
  border-radius: 12px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.block-name {
  font-weight: bolder;
  font-size: 18px;
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

.device-name {
  display: flex;
  justify-content: center;
  padding-top: 10px;
  font-size: medium;
}

.status-card {
  border-radius: 10px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--v-primary-darken1);
}

.status-container {
  padding-left: 20px;
  padding-bottom: 20px;
  padding-right: 20px;
}

.status-on {
  border: 3px solid #3CB371;
}

.status-off {
  border: 3px solid #FF5252;
}

.no-status {
  border: 3px solid #9E9E9E;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 14px;
}
</style>